import { UtmLeadProductType } from '@enums/UtmLeadProduct'

export const defaultDeeplink = 'https://ackoctv.onelink.me/pNs0/xk00tycj'
export const noChallanDoneIcon = 'https://acko-cms.ackoassets.com/Done_a0e2f8fc99.svg'
export const noChallanText = 'No traffic fines found'
export const previewTextCollapsed = 'Tap to view more'
export const previewTextExpanded = 'Tap to see less'
export const collapseImageSrc = 'https://acko-cms.ackoassets.com/collapse_db35a1fa0b.svg'
export const expandImageSrc = 'https://acko-cms.ackoassets.com/expand_5056e4f065.svg'
export const challanViolationMappingJsonSrc =
  'https://acko-cms.ackoassets.com/challan_Violation_Reduced_Form_781813bd0d.json'
export const nonVahanStateIconSrc = 'https://acko-cms.ackoassets.com/Bulb_icon_5f6343b442.svg'
export const greenTickSrc = 'https://acko-cms.ackoassets.com/Green_Tick_ede69c3129.svg'
export const evaluatingCarImageSrc = 'https://acko-cms.ackoassets.com/App_icon_03df89bf56.svg'
export const ackoUrl = 'https://www.acko.com/'
export const guidelineImageSrc = 'https://acko-cms.ackoassets.com/whatsapp_challan_guideline_14adc2400e.svg'
export const stateReplaceText = '{{state}}'
export const trafficLoaderText = 'Checking if you have traffic fines'
export const trafficReportText = 'Your traffic fines summary'
export const fetchUrlBase = '/api/app/'
export const minChallanListHeight = '220px'
export const WA_CHALLAN_OLD_FLOW_LEADS: string[] = [UtmLeadProductType.WHATSAPP_WINBACK_CHALLAN]
export const nonVahanStates = ['Telangana', 'Haryana', 'Andhra Pradesh', 'Delhi', 'Maharashtra', 'Karnataka']
export const guidelineText = [
  {
    text: 'We will check traffic fines on the official {{state}} website ',
    isBoldText: false,
  },
  {
    text: 'only with your consent',
    isBoldText: true,
  },
  {
    text: ' after logging in with an OTP.',
    isBoldText: false,
  },
]
export const infoText = [
  {
    text: 'Note:',
    isBoldText: true,
  },
  {
    text: ' The {{state}} govt. does not send traffic fines to Vahan.',
    isBoldText: false,
  },
]

export const WA_CHALLAN_REDIRECTION_LEADS: string[] = [
  UtmLeadProductType.NCX_WA_WNBCK_CHLN_P1,
  UtmLeadProductType.CX_WA_WNBCK_CHLN_P1,
  UtmLeadProductType.KA_DISC_CHLN_GOV,
]
